"use client";
import React from "react";
import { cn } from "@/lib/tailwind";
import SuggestionList from "./SuggestionList";

export interface IProps {
  open: boolean;
  searchTerm: string;
  locale: string;
  lang: string;
  translation: Record<string, string>;
  suggestionRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  enableVto: boolean;
}

const DesktopSuggesationMenu = ({
  open,
  searchTerm,
  lang,
  locale,
  translation,
  suggestionRef,
  onClose,
  enableVto,
}: IProps) => {
  return (
    <div
      ref={suggestionRef}
      className={cn(
        "max-h-[80vh] overflow-y-auto",
        "absolute left-0 top-[80px] min-h-40 w-full bg-white lg:block",
        "hidden shadow-[0_4px_4px_0_rgba(0,0,0,0.25)] transition-all duration-300",
        open
          ? "pointer-events-auto z-10 -translate-y-0 opacity-100"
          : "pointer-events-none -z-10 -translate-y-[10%] opacity-0",
      )}
    >
      <div className="container">
        <SuggestionList
          open={open}
          searchTerm={searchTerm}
          lang={lang}
          locale={locale}
          translation={translation}
          onClose={onClose}
          enableVto={enableVto}
        />
      </div>
    </div>
  );
};

export default DesktopSuggesationMenu;
